import { sanitizeChatMessage } from '../../utils/safeHtml';
import { chatAttachmentUrlFromMessage } from '../../utils/chatAttachment';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { InsertDriveFileOutlined, DoneAll, Done, ArrowDownwardSharp, QueryBuilderSharp, ZoomIn, DoneRounded, DoneAllRounded } from '@material-ui/icons';

import { Alert, Box, Button, Card, CardContent, CardMedia, Dialog, Grid, Typography } from '@mui/material';
import ChatNewMessage from '../ChatNewMessage';
import '../RoomList/room-list.css';
import { connect, useSelector } from 'react-redux';
import { ThemeContext } from '../ThemeContext/ThemeContext';
import { UpdateInProgressRooms, selectRoomAlert } from '../../redux/room/room.actions';
import { convidadosDaSala } from '../../utils/convidadosDaSala';
import { legendaDaImagem } from '../../utils/legendaDaImagem';
import { avisoDaJanela } from '../../utils/janelaDoWhatsapp';
import { Avatar, Chip, IconButton } from '@material-ui/core';
import ConfirmationModal from '../ConfirmationModal';
import './chat.css';
import FilePreview from '../FilePreview';
import { CheckCircleOutline, Info, InfoRounded, PlayArrow } from '@mui/icons-material';
import CustomAudioPlayer from '../CustomAudioPlayer';

const Chat = ({ mode = 'full', handleSendingMessage, ...props }) => {
    const [room, setRoom] = useState({});
    const [sendingFile, setSendingFile] = useState(false);

    const { theme } = useContext(ThemeContext);

    const clientMessage = useSelector(state => state.rooms.clientMessage);
    const searchRoom = props.inProgressRooms.find(room => room.room_id === props.roomId);
    const messagesEndRef = useRef(null);
    const buttonClickedRef = useRef(false);
    const { currentUser } = props;
    const user = currentUser ? currentUser : JSON.parse(localStorage.getItem('user'));
    const [autoScroll, setAutoScroll] = useState(true);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [lastRelevantMsg, setLastRelevantMsg] = useState(null);
    const serviceGroup = currentUser?.service_group
    const lastCheckedMsgIdRef = useRef(null);
    const roomAlert = useSelector(selectRoomAlert);
    // `null` na esmagadora maioria das salas -- so tem conteudo quando a sala e
    // de WhatsApp E o servidor disse que a janela de 24h fechou.
    const avisoDaJanelaDoWhatsapp = avisoDaJanela(room);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [pendingClosure, setPendingClosure] = useState();
    /*
     * TEM HISTORICO MAIS ANTIGO PARA BUSCAR?
     *
     * Era `const { currentPage, hasMore } = useSelector(state => state.whatsapp.pageInfo)`
     * -- e `pageInfo` so era preenchido por um evento da camada whatsapp-web.js,
     * removida em 31/08. `hasMore` ficava `undefined` para sempre: o botao
     * "Carregar mais mensagens..." NUNCA aparecia e a rolagem ate o topo nao
     * fazia nada. A conversa abria com as 30 ultimas e o resto era invisivel
     * (numa sala de 43 mensagens medida em 12/10/2026, 13 nao tinham como ser
     * vistas).
     *
     * Agora a conta e direta: o que esta desenhado contra o que a sala TEM,
     * numero que vem do proprio paginador da api. Isso continua certo mesmo
     * quando o socket substitui a lista pela conversa inteira, que e o que
     * quase todo evento faz.
     */
    const temHistoricoMaisAntigo = (props.messages?.length || 0) < (props.totalDeMensagens || 0);
    // A altura da lista ANTES de crescer, para a tela nao saltar -- ver o
    // efeito que restaura a posicao mais abaixo.
    const alturaAntesDeCarregarRef = useRef(null);



    const [selectedImage, setSelectedImage] = useState(null); // Estado para armazenar a URL da imagem selecionada
    const [open, setOpen] = useState(false); // Estado para controlar a abertura do modal

    // Função para abrir o modal ao clicar em uma imagem
    const handleClickOpen = (imageUrl) => {
        setSelectedImage(imageUrl); // Define a URL da imagem selecionada
        setOpen(true); // Abre o modal
    };

    // Função para fechar o modal
    const handleClose = () => {
        setOpen(false); // Fecha o modal
        setSelectedImage(null); // Limpa a imagem selecionada
    };

    /*
     * O ENCERRAMENTO POR INATIVIDADE SAIU DAQUI (12/10/2026).
     *
     * Era um `checkTime` num `setInterval` de 30 segundos, neste componente,
     * varrendo `lastMessages` do redux. Quatro defeitos, todos relatados em
     * producao:
     *
     * 1. Ao encerrar, ele apagava o registro da ultima interacao para
     *    "esquecer" a sala. Sem marca de "ja encerrada", o tique seguinte
     *    recalculava pela mensagem antiga -- ainda velha -- e REENVIAVA a
     *    mensagem e refinalizava. A cada 30 segundos, para sempre.
     * 2. `lastMessages` nunca e limpo, entao a sala encerrada seguia sob o
     *    relogio depois de sair da lista.
     * 3. Cada navegador aberto rodava seu proprio relogio. Em "Todas as
     *    conversas" o operador carregava as salas dos outros e passava a
     *    encerra-las, assinando com o nome dele.
     * 4. Usava o `time_config` do departamento de QUEM ESTAVA LOGADO,
     *    aplicado a todas as salas, de qualquer departamento.
     *
     * E so existia com uma conversa selecionada: sem ninguem com a tela
     * aberta, nada era encerrado.
     *
     * Agora quem faz isso e o comando `chat:encerrar-inativos` da api, uma
     * vez por minuto, com as mesmas regras (ver
     * `AppServicesChatDecisaoDeInatividade`). A mensagem continua
     * aparecendo nesta tela ao vivo: o comando avisa o ws por
     * `AvisoNaTelaDoOperador`, e ela chega pelo `NEW_CHAT_MESSAGE_EVENT`
     * como qualquer outra.
     *
     * NAO reintroduza um relogio aqui. Dois motores para a mesma regra
     * mandam a mensagem duas vezes.
     */

    useEffect(() => {
        if (searchRoom !== undefined) {
            setRoom(searchRoom);
            // Resetar isFirstLoad quando mudar de chat
            setIsFirstLoad(true);
        }
    }, [searchRoom]);

    useEffect(() => {
        if (
            room.messages && room.messages.length > 0 &&
            props.messages && props.messages.length > 0 &&
            room.messages[room.messages.length - 1].id !== props.messages[props.messages.length - 1].id
        ) {
            setRoom(prevRoom => ({ ...prevRoom, messages: props.messages }));
        }
        // eslint-disable-next-line
    }, [props.messages]);

    // Responde ao Orby (botão "Usar este chat") com cliente + mensagens recentes.
    useEffect(() => {
        const handler = () => {
            try {
                const sr = props.selectedRoom || {};
                const client = sr.client || {};
                const company = client.company || {};
                const clientName = client.name || 'Cliente';
                const companyName = company.business_name || company.name || '';
                const code = company.code || '';
                const strip = (s) => String(s || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
                const msgs = Array.isArray(props.messages) ? props.messages : [];
                const recent = msgs.slice(-25).filter(m => m.type !== 4).map((m) => {
                    const who = m.type === 0
                        ? clientName
                        : (m.type === 5 ? `${m.user?.name || 'Operador'} [interna]` : (m.user?.name || 'Operador'));
                    return `${who}: ${strip(m.message).slice(0, 300)}`;
                });
                const head = [
                    `Chat com ${clientName}${companyName ? ` / ${companyName}` : ''}${code ? ` (cód. ${code})` : ''}`,
                    '',
                    'Conversa (mais antigas primeiro):',
                ];
                const text = [...head, ...recent].join('\n');
                window.dispatchEvent(new CustomEvent('orbyContextResponse', { detail: { label: `Chat: ${clientName}`, text } }));
            } catch (e) {
                window.dispatchEvent(new CustomEvent('orbyContextResponse', { detail: {} }));
            }
        };
        window.addEventListener('orbyRequestContext', handler);
        return () => window.removeEventListener('orbyRequestContext', handler);
    }, [props.selectedRoom, props.messages]);

    const handleChangeClosingTime = async (roomId, isClosing) => {
        const room = props.inProgressRooms.find(iRoom => iRoom.room_id === roomId);
        let invitedUsersParse = room.invited_users;
        let invitedUsers = JSON.parse(invitedUsersParse);

        await props.UpdateInProgressRooms(roomId, user?.id, user?.id, invitedUsers, [props.currentClient], { is_closing_time_cancelled: isClosing ? 1 : 0 });
        await props.sendMessage(`O encerramento automático do chat está ${isClosing ? 'inativo' : 'ativo'}!`, user, roomId, 5, user.name);
    }

    // O `setInterval(checkTime, 30000)` que ficava aqui saiu junto com o
    // `checkTime` -- ver a nota longa acima. De quebra, ele era recriado a cada
    // render (o `checkTime` tinha `props` nas dependências), então o relógio
    // só chegava aos 30 segundos quando a tela ficava parada.

    const handleMessage = (message) => {
        const archive = message.archive ? message.archive.split('/') : null;

        if (!message.archive) {
            if (message.type === 5 && message.user.name) {
                return (
                    <Grid sx={{ backgroundColor: 'transparent', borderRadius: '5px' }}>
                        {/* Tambem e HTML, como as demais: ver AttendancePanelPage. */}
                        <Typography variant="body2" component="div" dangerouslySetInnerHTML={{ __html: sanitizeChatMessage(message.message) }} />
                    </Grid>
                );
            }
            return <SafeHtmlMessage htmlContent={message.message} message={message} />;
        } else if (message.archive?.startsWith("data:image") || /\.(jpeg|jpg|gif|png)$/i.test(message.archive)) {
            // Se a mensagem é uma imagem
            const image = chatAttachmentUrlFromMessage(message);
            // Legenda estilo WhatsApp: quando a pessoa anexa imagem e digita um
            // texto, ele vem no campo message. A regra de quando ele vale a pena
            // vive em `legendaDaImagem` -- ela esconde nome de arquivo e o
            // marcador de midia da API, que so fazem sentido quando a imagem
            // NAO esta na tela.
            const caption = legendaDaImagem(message.message);
            return (
                <Box sx={{ maxWidth: '100%', width: '20rem' }}>
                    <Box className='avatar-container' sx={{ maxWidth: '100%', borderRadius: '10px', overflow: 'hidden', width: '100%', position: 'relative' }}>
                        <CardMedia
                            component="img"
                            image={image}
                            alt={caption || message.message}
                            sx={{ borderRadius: '10px', maxHeight: '200px', objectFit: 'cover', cursor: 'pointer', height: '5rem' }}
                            onClick={() => handleClickOpen(image)}
                        />
                        <Grid className='avatar-overlay' sx={{ backgroundColor: 'transparent' }} onClick={() => handleClickOpen(image)}>
                            <ZoomIn />
                        </Grid>
                    </Box>
                    {caption && (
                        <Typography sx={{ mt: 0.5, fontSize: '0.9rem', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                            {caption}
                        </Typography>
                    )}
                </Box>
            );
        } else if (message.archive?.startsWith("data:audio") || /\.(ogg|mp3)$/i.test(message.archive)) {
            try {
                let base64Data = chatAttachmentUrlFromMessage(message);
                if (base64Data.includes('base64,')) {
                    base64Data = base64Data.split('base64,')[1];
                }

                // const byteCharacters = atob(base64Data);
                // const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
                // const byteArray = new Uint8Array(byteNumbers);
                // const blob = new Blob([byteArray], { type: 'audio/ogg' }); // Removido o codecs
                // const audioUrl = URL.createObjectURL(blob);

                return (
                    <CustomAudioPlayer archive={message.archive} roomId={message.room_id} />
                );

            } catch (err) {
                console.error('Erro ao processar áudio:', err);
                return <Typography variant="caption">Áudio inválido</Typography>;
            }
        } else {
            // Exibe um ícone de arquivo e link de download para outros tipos de arquivos
            const fileUrl = chatAttachmentUrlFromMessage(message);

            // Usa o nome original do arquivo do campo message
            // Se message contém o nome original, usa ele; senão usa o nome do arquivo salvo
            let fileName = message.message || message.archive.split('/').pop();

            // Verifica se é um PDF para exibir ícone específico
            const isPdfFile = /\.pdf$/i.test(fileName) || /\.pdf$/i.test(message.archive);

            return (
                <Grid
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '8px',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                    }}
                    onClick={() => handleClickOpen(fileUrl)}
                >
                    {isPdfFile ? (
                        <img
                            src={require('../../assets/icons/pdf-icon.png')}
                            alt="PDF"
                            style={{ width: '24px', height: '24px' }}
                        />
                    ) : (
                        <InsertDriveFileOutlined />
                    )}
                    <Typography variant="body2" sx={{ flex: 1 }}>
                        {fileName}
                    </Typography>
                </Grid>
            );
        }
    };

    const calculateTimePassed = (messageTime) => {
        const currentTime = new Date();
        const messageDate = new Date(messageTime);
        const diffInSeconds = Math.floor((currentTime - messageDate) / 1000);

        if (diffInSeconds < 60) {
            return `${diffInSeconds} segundos atrás`;
        }

        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) {
            return `${diffInMinutes} minutos atrás`;
        }

        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) {
            return `${diffInHours} horas atrás`;
        }

        const diffInDays = Math.floor(diffInHours / 24);
        return `${diffInDays} dias atrás`;
    }

    const handleInfo = message => {
        var time = message.created_at.split("T");
        time = time[1].split(":");
        const timePassed = calculateTimePassed(message.created_at);

        if (message.type) {
            if (message.type === 5) {
                return (
                    <Grid sx={{ backgroundColor: 'transparent', display: 'flex' }}>
                        <time
                            title={`Enviado há ${timePassed}`}
                            dateTime={message.created_at}
                        >
                            {time[0]}:{time[1]}
                        </time>
                    </Grid>
                )
            }
            if (message.read_at) {
                return (
                    <Grid sx={{ backgroundColor: 'transparent', display: 'flex' }}>
                        <Grid>
                            <time
                                title={`Enviado há ${timePassed}`}
                                dateTime={message.created_at}
                            >
                                {time[0]}:{time[1]}
                            </time>
                        </Grid>
                        <Grid>
                            <DoneAllRounded style={{ fontSize: '14px', color: '#63ACE5', marginLeft: '1%' }} />
                        </Grid>
                    </Grid>
                )
            } else if (message.meta?.ack === 2) {
                return (
                    <Grid sx={{ backgroundColor: 'transparent', display: 'flex' }}>
                        <Grid>
                            <time
                                title={`Enviado há ${timePassed}`}
                                dateTime={message.created_at}
                            >
                                {time[0]}:{time[1]}
                            </time>
                        </Grid>
                        <Grid >
                            <DoneAllRounded style={{ fontSize: '14px', marginLeft: '1%' }} />
                        </Grid>
                    </Grid>
                )
            } else {
                return (
                    <Grid sx={{ backgroundColor: 'transparent', display: 'flex' }}>
                        <Grid>
                            <time
                                title={`Enviado há ${timePassed}`}
                                dateTime={message.created_at}
                            >
                                {time[0]}:{time[1]}
                            </time>
                        </Grid>
                        <Grid>
                            <Done style={{ fontSize: '14px', marginLeft: '1%' }} />
                        </Grid>
                    </Grid>
                )
            }
        } else {
            if (message.read_at) {
                return (
                    <Grid sx={{ backgroundColor: 'transparent', display: 'flex' }}>
                        <Grid>
                            <time
                                title={`Enviado há ${timePassed}`}
                                dateTime={message.created_at}
                            >
                                {time[0]}:{time[1]}
                            </time>
                        </Grid>
                    </Grid>
                )
            } else {
                return (
                    <Grid sx={{ backgroundColor: 'transparent', display: 'flex' }}>
                        <Grid>
                            <time
                                title={`Enviado há ${timePassed}`}
                                dateTime={message.created_at}
                            >
                                {time[0]}:{time[1]}
                            </time>
                        </Grid>
                    </Grid>
                )
            }
        }
    };

    const [newMessageNotification, setNewMessageNotification] = useState(false)
    const [firstUnreadMessageIndex, setFirstUnreadMessageIndex] = useState(null);
    const { setUnreadCount, unreadCount, messages } = props;

    useEffect(() => {
        const index = messages.findIndex(message => !message.read_at && message.type === 0);
        setFirstUnreadMessageIndex(index);

        if ((unreadCount + 1) >= 1) {
            setNewMessageNotification(true);
        }
        // eslint-disable-next-line
    }, [messages]);

    useEffect(() => {
        if (messagesEndRef.current) {
            // Sempre fazer scroll na primeira carga do chat
            if (isFirstLoad) {
                setTimeout(() => {
                    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
                }, 100);
                setIsFirstLoad(false);
                if (typeof setUnreadCount === 'function')
                    setUnreadCount(0);
            }
            // Só fazer scroll se autoScroll for true (usuário está no final)
            else if (autoScroll) {
                setTimeout(() => {
                    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
                }, 100);
                if (typeof setUnreadCount === 'function')
                    setUnreadCount(0);
            }
        }
        // eslint-disable-next-line
    }, [messages, autoScroll, isFirstLoad]);

    useEffect(() => {
        const messageList = document.querySelector('.messages-list');
        if (!messageList) return;

        const avaliarPosicao = (porRolagemDoOperador) => {
            const { scrollTop, scrollHeight, clientHeight } = messageList;
            // Verificar se está no final da lista (com margem de 10px)
            const atBottom = Math.abs(scrollHeight - scrollTop - clientHeight) < 10;

            if (!buttonClickedRef.current) {
                setAutoScroll(atBottom);
            }

            /*
             * SÓ uma rolagem DO OPERADOR pede histórico.
             *
             * A chamada inicial logo abaixo existe para acertar o `autoScroll`
             * assim que a conversa abre, e nesse instante a lista ainda não
             * rolou: `scrollTop` é zero, que é a mesma leitura de "estou no
             * topo". Sem esta guarda, abrir a conversa já buscava a página 2 --
             * e pior, em cadeia: cada página carregada muda
             * `temHistoricoMaisAntigo`, o efeito re-registra o ouvinte, a
             * chamada inicial roda de novo e busca a seguinte, até acabar o
             * histórico. Medido em 12/10/2026: a conversa abria com as 43
             * mensagens de uma vez, sem ninguém rolar nada.
             */
            if (!porRolagemDoOperador) return;

            // Chegou ao topo: busca o bloco anterior.
            //
            // A altura e guardada ANTES do pedido. Quando as antigas entram, o
            // navegador mantem o `scrollTop` em zero e a tela saltaria para a
            // mensagem mais velha de todas -- o efeito logo abaixo devolve o
            // operador para onde ele estava lendo.
            if (scrollTop === 0 && temHistoricoMaisAntigo) {
                alturaAntesDeCarregarRef.current = scrollHeight;
                props.carregarMaisAntigas();
            }
        };

        const aoRolar = () => avaliarPosicao(true);

        messageList.addEventListener('scroll', aoRolar);
        // Verificar posição inicial do scroll
        avaliarPosicao(false);

        return () => {
            messageList.removeEventListener('scroll', aoRolar);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [temHistoricoMaisAntigo, props.roomId]);

    /**
     * Devolve o operador para onde ele estava lendo depois que as mensagens
     * antigas entraram no topo.
     *
     * Sem isto, carregar historico joga a tela para a mensagem mais velha de
     * todas: o conteudo cresce para cima e o `scrollTop` continua em zero. A
     * diferenca entre a altura nova e a antiga e exatamente o quanto a tela
     * andou.
     */
    useEffect(() => {
        const alturaAntes = alturaAntesDeCarregarRef.current;
        if (alturaAntes === null) return;

        const lista = document.querySelector('.messages-list');
        if (!lista) return;

        const cresceu = lista.scrollHeight - alturaAntes;
        if (cresceu > 0) lista.scrollTop = cresceu;

        alturaAntesDeCarregarRef.current = null;
    }, [props.messages]);

    const SafeHtmlMessage = ({ htmlContent, message }) => (
        <>
            {message.meta?.customType === 'contact_card' ? (
                <Box className="contact-card" sx={{ bgcolor: theme.palette.background.card }}>
                    <Avatar
                        src={message.meta.contactInfo?.profilePicUrl}
                        alt={message.meta.contactInfo?.name}
                        className="contact-avatar"
                    />
                    <Box className="contact-details">
                        <Typography variant="subtitle1" className="contact-label" sx={{ color: theme.palette.text.button }}>
                            Contato
                        </Typography>
                        <Typography variant="body1" className="contact-name" sx={{ color: theme.palette.text.button }}>
                            {message.meta.contactInfo.name || 'Sem nome'}
                        </Typography>
                        <Typography variant="body2" className="contact-number" sx={{ color: theme.palette.text.caption }}>
                            {message.meta.contactInfo.number}
                        </Typography>
                        <Grid bgcolor={'transparent'}>
                            <Button
                                startIcon={<Info fontSize='small' />}
                                sx={{
                                    bgcolor: theme.palette.background.messageBox,
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        bgcolor: theme.palette.primary.dark,
                                    },
                                    borderRadius: '14px',
                                    height: '1.4rem',
                                }}
                            >
                                <Typography variant="caption" fontSize={14}>
                                    Enviar Mensagem
                                </Typography>
                            </Button>
                        </Grid>
                    </Box>
                </Box>
            ) : <div dangerouslySetInnerHTML={{ __html: sanitizeChatMessage(htmlContent) }} />}
        </>

    );


    const UpdateInProgressRooms = (userId) => {
        const room = props.inProgressRooms.find(iRoom => iRoom.room_id === props.selectedRoom.room_id);

        if (!room) {
            setConfirmationModal(false);

            return;
        }

        const invitedUsers = convidadosDaSala(room);

        if (!invitedUsers.includes(userId)) {
            invitedUsers.push(userId);
            if (room.user_id !== user.id) {
                props.UpdateInProgressRooms(room.room_id, room.user_id, user?.id, invitedUsers, [props.currentClient]);
            } else {
                props.UpdateInProgressRooms(room.room_id, user?.id, user?.id, invitedUsers, [props.currentClient]);
            }
        }
        setConfirmationModal(false);
    };

    return (
        /* `xs` é prop de item; em container o MUI avisa. Os três valores
           abaixo são o que o `xs={12}` gerava -- ver
           `src/avisosDoConsole.test.js`. */
        <Grid className='chat' container sx={{ flexBasis: '100%', flexGrow: 0, maxWidth: '100%' }}>
            <Grid item style={{ maxHeight: '100%', minHeight: '100%' }} xs={12}
                sx={{ backgroundColor: theme.palette.background.default }}>
                <ol className="messages-list" onClick={() => {
                    if (props.setUnreadCount)
                        props.setUnreadCount(0);
                    setNewMessageNotification(false);
                    props.messageReadFocus();
                }}>
                    {temHistoricoMaisAntigo && (
                        <Grid container justifyContent={'center'} sx={{ bgcolor: 'transparent' }}>
                            <Grid sx={{
                                borderRadius: "12px", bgcolor: theme.palette.background.secondary,
                                color: theme.palette.text.button, margin: '1rem', padding: '0.5rem 1rem',
                                '&:hover': {
                                    bgcolor: theme.palette.primary.dark,
                                },
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginLeft: '2rem',
                                marginTop: '1rem',
                                marginBottom: '1rem',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                textTransform: 'none',
                                width: '25%',
                                cursor: 'pointer',
                            }}
                                onClick={() => {
                                    const lista = document.querySelector('.messages-list');
                                    if (lista) alturaAntesDeCarregarRef.current = lista.scrollHeight;
                                    props.carregarMaisAntigas();
                                }}>
                                Carregar mais mensagens...
                            </Grid>
                        </Grid>
                    )}
                    {props.messages.map((message, i) => (
                        <li key={i} ref={i === props.messages.length - 1 ? messagesEndRef : null}>
                            <Grid sx={{ backgroundColor: 'transparent' }}>
                                <Grid>
                                    {newMessageNotification && i === firstUnreadMessageIndex ?
                                        <p style={{ textAlign: 'center', color: '7F8181', fontSize: '10px' }}>Novas mensagens</p> : ''
                                    }
                                </Grid>
                                <Grid container sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: message.type ? 'flex-end' : 'flex-start',
                                    marginTop: '1.5rem'
                                }}>
                                    {/*
                                      * Autor ACIMA da bolha, não ao lado.
                                      *
                                      * Numa linha flex com `alignItems: center`, o nome virava uma
                                      * coluna à esquerda da bolha e lia como parte da mensagem. Acima,
                                      * alinhado ao lado de quem escreveu, ele vira o que é: rótulo.
                                      *
                                      * Esta coluna também passou a carregar o `maxWidth`, que antes
                                      * ficava na bolha -- senão o nome escaparia do limite dela.
                                      */}
                                    <Grid item sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: message.type ? 'flex-end' : 'flex-start',
                                        maxWidth: '75%',
                                        minWidth: 0,
                                        marginLeft: '1rem',
                                    }}>
                                        {(message.type !== 4 && message.type !== 0) && message.user && (
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    color: 'text.secondary',
                                                    fontWeight: 600,
                                                    marginBottom: '2px',
                                                    paddingX: '4px',
                                                }}
                                            >
                                                {message.user.name}
                                            </Typography>
                                        )}
                                        <Grid item sx={{
                                            padding: '10px 14px',
                                            /*
                                             * A cor de destaque vai para quem ESCREVE, não para quem
                                             * chega.
                                             *
                                             * Era o contrário: a mensagem do cliente (tipo 0) levava o
                                             * azul e a do operador ficava cinza -- o inverso de
                                             * qualquer mensageiro, onde o que você escreve é o que
                                             * recebe cor.
                                             *
                                             * Os tipos foram conferidos nos dados, e por isso a
                                             * condição é `=== 1` e não "qualquer coisa diferente de
                                             * zero": tipo 0 é o cliente, tipo 1 é o operador (tem
                                             * autor) e tipo 4 é mensagem AUTOMÁTICA do sistema, sem
                                             * autor. Com a regra frouxa, o texto automático de
                                             * boas-vindas ganharia a cor de quem atende e pareceria
                                             * escrito por uma pessoa.
                                             */
                                            backgroundColor: message.type === 3 ? 'transparent'
                                                : message.type === 5 ? theme.palette.background.internal
                                                    : message.type === 1 ? theme.palette.background.received
                                                        : theme.palette.background.messageBox,
                                            // `background.received` é azul escuro nos dois temas: o
                                            // texto em cima dele precisa ser claro, não o padrão.
                                            color: message.type === 1 ? '#ffffff' : 'inherit',
                                            borderRadius: '12px',
                                            marginBottom: '4px',
                                        }} className={!message.type ? "received-message" : 'my-message'}>
                                            {handleMessage(message)}
                                        </Grid>
                                    </Grid>

                                    <Typography variant="caption" sx={{
                                        height: '3rem',
                                        alignSelf: message.type ? 'flex-end' : 'flex-start',
                                        color: '#7F8181',
                                        fontSize: '10px',
                                        marginRight: message.type ? '2%' : 0,
                                        marginLeft: message.type ? '1%' : '2%',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        {handleInfo(message)}
                                    </Typography>
                                </Grid>

                            </Grid>
                        </li>
                    ))}
                    {roomAlert && (
                        <Box item xs={12} sx={{
                            position: 'absolute',
                            bgcolor: 'rgba(255, 255, 0, 0.6)',
                            width: '98.5%',
                            padding: theme.spacing(1),
                            textAlign: 'center',
                            bottom: '11rem',
                            left: 0,
                            zIndex: 9999,
                            borderRadius: '0.5rem',
                            margin: '0.875rem 0 0.875rem 0.5rem',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Typography variant="subtitle1" sx={{ color: theme.palette.text.button }}>
                                Você não está participando desta sala.
                            </Typography>
                            <Button onClick={() => setConfirmationModal(true)} sx={{
                                bgcolor: theme.palette.background.messageBox,
                                color: theme.palette.text.primary,
                                '&:hover': {
                                    bgcolor: theme.palette.primary.dark,
                                },
                                padding: theme.spacing(1),
                                borderRadius: '8px',
                                marginLeft: '1rem'
                            }}>
                                Entrar na Sala
                            </Button>
                        </Box>
                    )}

                    <ConfirmationModal
                        title={"Teste"}
                        isOpen={confirmationModal}
                        handleClose={() => setConfirmationModal(false)}
                        handleAction={() => UpdateInProgressRooms(currentUser.id)}
                    />
                    {/* Display "Sending file" message when uploading a file */}
                    {sendingFile ?
                        <li key={99999}>
                            <Grid className="message-container">
                                <Grid className={`message-item my-message`}>
                                    <InsertDriveFileOutlined /> Enviando arquivo...
                                </Grid>
                                <p style={{ textAlign: 'right', color: '7F8181', fontSize: '10px', marginRight: '2%' }}></p>
                            </Grid>
                        </li>
                        :
                        ''
                    }
                </ol>
                {/* Modal para visualizar a imagem expandida */}
                {/* <Dialog open={open} onClose={handleClose} maxWidth="lg">
                    <CardMedia
                        component="img"
                        image={selectedImage} // Exibe a imagem selecionada no modal
                        alt="Imagem Expandida"
                        sx={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain' }}
                    />
                </Dialog> */}
                {selectedImage && (
                    <FilePreview
                        selectedFile={selectedImage}
                        setSelectedFile={setSelectedImage}
                        isChat={true}
                    />
                )}

                {!autoScroll &&
                    <Grid
                        sx={{
                            position: 'fixed',
                            bottom: '11rem',
                            right: '3rem',
                            zIndex: 9999,
                            borderRadius: '50%',
                            backgroundColor: theme.palette.background.hover,
                        }}>
                        <IconButton onClick={() => {
                            setAutoScroll(true);
                            buttonClickedRef.current = true;
                            // Fazer scroll manual para o final
                            if (messagesEndRef.current) {
                                messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
                            }
                            setTimeout(() => buttonClickedRef.current = false, 500);
                        }}>
                            <ArrowDownwardSharp />
                        </IconButton>
                    </Grid>
                }
                {/*
                  * `clientMessage` guarda a SALA em que o cliente está
                  * digitando. Aqui a comparação quase sempre dá no mesmo --
                  * o sinal vem da conversa aberta, que é esta --, mas ela
                  * mantém a regra em UM lugar só: a linha da lista
                  * (`Room/index.jsx`) faz a mesma pergunta, e dois critérios
                  * para o mesmo aviso divergem no dia em que um deles mudar.
                  */}
                <Grid style={clientMessage && clientMessage === props.roomId ?
                    { display: 'inline', textAlign: 'center', color: '7F8181', fontSize: '10px' }
                    :
                    { display: 'none', textAlign: 'center', color: '7F8181', fontSize: '10px' }}
                >Cliente está digitando ....</Grid>

                {/*
                  * A janela de 24h do WhatsApp, avisada ANTES de o operador digitar.
                  *
                  * Sem isto a falha e silenciosa e da pior especie: ele responde, ve a
                  * PROPRIA mensagem aparecer no chat, e o cliente nunca recebe -- a API
                  * recusa o envio e so o log sabe.
                  *
                  * O campo de mensagem continua HABILITADO de proposito. Quem decide o
                  * que chega e a Meta, e a API ja e a rede embaixo; se este aviso
                  * estiver errado (sala carregada ha horas, cliente escreveu depois e a
                  * lista ainda nao recarregou), travar a tela impediria um atendimento
                  * que funcionaria. Avisar custa nada; bloquear a toa custa o cliente.
                  */}
                {avisoDaJanelaDoWhatsapp && (
                    <Alert severity="warning" sx={{ margin: '0 0.5rem 0.5rem 0.5rem' }}>
                        {avisoDaJanelaDoWhatsapp}
                    </Alert>
                )}

                <ChatNewMessage
                    messages={props.messages}
                    room={room}
                    roomId={props.roomId}
                    sendMessage={props.sendMessage}
                    sendFile={props.sendFile}
                    setSendingFile={setSendingFile}
                    handleSendingMessage={handleSendingMessage}
                    messageReadFocus={props.messageReadFocus}
                    internalCharacter={serviceGroup?.text_config.internal_character}
                    handleChangeClosingTime={handleChangeClosingTime}
                    pendingClosure={pendingClosure}
                    setPendingClosure={setPendingClosure}
                />
                {/* Chat footer with buttons */}
                {/* <ChatFooter sendFile={props.sendFile} /> */}
            </Grid>
        </Grid>
    );
};

const mapStateToProps = state => {
    const { user, rooms, clients } = state;
    const { currentUser } = user;
    const { inProgressRooms } = rooms;
    const { currentClient } = clients;

    return { currentUser, inProgressRooms, currentClient };
};

const mapDispatchToProps = dispatch => ({
    UpdateInProgressRooms: (roomId, userId, userIdActual, invitedUsers, ticketData, options) => dispatch(UpdateInProgressRooms(roomId, userId, userIdActual, invitedUsers, ticketData, options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Chat);